import { tv } from "@/utils/tv.config";
import { VariantProps } from "tailwind-variants";

const numberFieldClasses = tv({
  slots: {
    root: ["flex"],
    scrubArea: ["cursor-ew-resize"],
    scrubAreaCursor: ["drop-shadow-[0_1px_1px_#0008] filter"],
    label: ["cursor-ew-resize text-sm font-medium text-gray-900"],
    fieldGroup: ["flex"],
    decrement: [
      "flex size-10 items-center justify-center rounded-tl-xl rounded-bl-xl border border-gray-300 bg-gray-50 bg-clip-padding text-gray-900 select-none hover:bg-gray-100 active:bg-gray-100",
    ],
    input: [
      "h-10 w-20 border-t border-b border-gray-300 text-center text-base text-gray-900 tabular-nums focus:z-10 focus:outline focus:outline-0 focus:-outline-offset-1 focus:outline-blue-800",
    ],
    increment: [
      "flex size-10 items-center justify-center rounded-tr-xl rounded-br-xl border border-gray-300 bg-gray-50 bg-clip-padding text-gray-900 select-none hover:bg-gray-100 active:bg-gray-100",
    ],
  },
  variants: {
    inline: {
      true: {
        root: ["flex-row", "items-center"],
      },
      false: {
        root: ["flex-col items-start"],
      },
    },
    hasLabel: {
      true: {
        root: "",
      },
    },
    noLabel: {
      true: {
        label: "sr-only",
      },
    },
  },
  compoundVariants: [
    {
      inline: true,
      hasLabel: true,
      class: {
        root: ["gap-2"],
      },
    },
    {
      inline: false,
      hasLabel: true,
      class: {
        root: ["gap-1"],
      },
    },
  ],
});

export const {
  root: numberInputRootClasses,
  scrubArea: numberInputScrubAreaClasses,
  scrubAreaCursor: numberInputScrubAreaCursorClasses,
  label: numberInputLabelClasses,
  fieldGroup: numberInputFieldGroupClasses,
  decrement: numberInputDecrementClasses,
  input: numberInputClasses,
  increment: numberInputIncrementClasses,
} = numberFieldClasses();

export type NumberFieldVariants = VariantProps<typeof numberFieldClasses>;
